import { HStack } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

export const SaleTier = () => {
  return (
    <HStack horizontalAlignment="center" className="position-absolute top-0 start-0 end-0" data-e2e="sale-tier">
      <div className="badge rounded-pill badge-warning fs-12 my-1 py-4px px-12px">
        <FormattedMessage id="tile.SaleTier" />
      </div>
    </HStack>
  );
};
